module.exports = __webpack_public_path__ + "img/gongzonghaokaifa.9c783d12.png";